import OrderAddressSearchComponent from "../../order/OrderAddressSearchComponent.tsx";
import {useState} from "react";
import ConditionsSpecificAddressComponent from "../../broadband/ConditionsSpecificAddressComponent.tsx";

const preDefault = "fra"
const defaultPrice = 299
const time = '6 mdr.'
const campaignPrice = 99
const min6 = (6 * campaignPrice)

export default function HiperLigFiberHeroComponent() {
    const [showPopUp, setShowPopup] = useState<boolean>(false);

    return (
        <div id="hero-container" className="hero-container hero-container--hiperligfiber darkteal">
            <div className="hero-background-wrapper">
                <div className="hero-background"></div>
            </div>

            <div className="hero-content text-right">
                <h1>
                    <span className="hero-pre-price"><strong>Få 1000 Mbit</strong> <br/>fibernet til kun</span>
                    <span className="hero-price">
                        <span className="price">{campaignPrice}</span>
                        <span className="price-comma-dash">,-</span>
                        <span className="price-md price-md-right">/md. <br/>i {time}</span>
                    </span>
                    <span className="post-price">Herefter fra <strong>{defaultPrice} kr./md.</strong></span>
                </h1>
            </div>

            <div className="address-wrap">
                <h2>
                    Se hvilket tilbud du kan få
                    <span className="scroll-down-arrow"></span>
                </h2>
                <OrderAddressSearchComponent/>
            </div>

            <p className="conditions">
                <span>Kampagnetilbuddet er et eksempel, og gælder fiber på</span>{' '}
                <button className={'link'} onClick={() => setShowPopup(true)}>udvalgte adresser</button>{' '}
                <span>
                    og for nye kunder, som ikke har en aktiveret fiberforbindelse.
                    Min. pris i 6 mdr. fra {min6} kr.
                    Pris efter {time} {preDefault} {defaultPrice} kr./md.
                </span>
            </p>

            <ConditionsSpecificAddressComponent show={showPopUp} setShow={setShowPopup} />
        </div>
    )
}
